import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NotFoundRoutingModule } from './not-found-routing.module';
import { NotFoundPage } from './pages/not-found/not-found.page';

@NgModule({
  declarations: [NotFoundPage],
  imports: [CommonModule, NotFoundRoutingModule],
})
export class NotFoundModule {}
